module.exports = __webpack_public_path__ + "img/levelup-logo.e87a5862.svg";